<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-check-circle-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm9.7 15.953l1.415 1.415a1 1 0 010 1.414L22.387 33.51a1 1 0 01-1.414 0l-7.32-7.321a1 1 0 010-1.414l1.413-1.415a1 1 0 011.414 0l5.2 5.2 10.607-10.607a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconCheckCircleFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
